export function colorBasedOnAttendanceRate(rate) {
    return rate >= 100 ? 'lime' :
        rate >= 50 ? 'emerald' :
            rate >= 20 ? 'amber' :
                'rose';
}